import { CustomTable, Combobox } from "medere-ui-framework"
import { useIntl } from "react-intl"
import { useEffect, useId, useRef, useState } from "react"
import { Column } from "primereact/column"
import { getValorizedExistences, exportValorizedExistencesReport, getAllSectors } from "../servicesHooks/Stock/useStockService"
import { useSearchParams } from "react-router"

function ValorizedExistencesReportView() {
    
    const [searchParams] = useSearchParams();
    const healthPatientServiceId: number = Number(searchParams.get('healthPatientServiceID'));
    const initialDateTime: Date = new Date(searchParams.get('initialDateTime') || '');
    const finalDateTime: Date = new Date(searchParams.get('finalDateTime') || '');
    const name: string | null = searchParams.get('name');
    const serviceEnded: boolean | null = searchParams.get('showProfessionals') === 'true';
    const [sector, setSector] = useState<{ sector: number; name: string } | null>(null);

    const tableRef = useRef(null)
    const intl = useIntl();
    const formattedFromDate = initialDateTime ? initialDateTime.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : "";
    const formattedToDate = finalDateTime ? finalDateTime.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : "";

    return (
        <div className="min-h-screen px-4 pt-2 flex flex-column viewContainer">
            <h2 className="text-lg font-semibold mb-2">Existencias valorizadas</h2>
            <Combobox
                getItems={getAllSectors}
                optionLabel="name"
                value={sector}
                setValue={setSector}
                params={filterValue => ({ filterValue })}
                placeholder={intl.formatMessage({ id: 'Select' })}
                label={intl.formatMessage({ id: 'Sector' })}
            />
            <CustomTable
                idTable={useId()}
                ref={tableRef}
                showGridlines
                hideFiltersButton
                getItems={getValorizedExistences}
                params={{sector: sector ?? undefined}}
                exportItems={[{ label: "Excel", icon: "pi-file-excel", onExport: exportValorizedExistencesReport }]}
                className='crudTable'
            >   
                <Column field="sector" header="Sector" className="column" pt={{headerContent: {className: "justify-content-center"}}} 
                />
                <Column field="item" header="Item" className="column"  style={{ textAlign: 'center' }} />
                <Column field="lastpurchase" header="Última Compra" className="column" pt={{headerContent: {className: "justify-content-center"}}} 
                body={(record) => {
                    const purchaseDate = new Date(record.lastpurchase);
                    const formattedDate = purchaseDate.getFullYear() < 2000 ? "" : purchaseDate.toLocaleDateString('es-ES');
                    return <span>{formattedDate}</span>;
                }} />
                <Column field="qty" header="Cantidad" className="column" pt={{headerContent: {className: "justify-content-center"}}} 
                />
                <Column field="unitprice" header="Precio Unitario" className="column" pt={{headerContent: {className: "justify-content-center"}}} 
                />
                <Column field="unitcost" header="Costo Unitario" className="column" pt={{headerContent: {className: "justify-content-center"}}} 
                />
                <Column field="_valueprice" header="Precio" className="column" pt={{headerContent: {className: "justify-content-center"}}} 
                />
                <Column field="_valuecost" header="Costo" className="column" pt={{headerContent: {className: "justify-content-center"}}} 
                />
            </CustomTable>
        </div>
    )
}

export default ValorizedExistencesReportView;
